<div class="router-bar">
  <div class="materials-order-route current-route">
    <button mat-button [routerLink]="['/orders/list']">Orders</button>
  </div>
  <div class="materials-order-route">
    <button mat-button [routerLink]="['/orders/vendors']">Vendors</button>
  </div>
  <div class="materials-order-route">
    <button mat-button [routerLink]="['/orders/materials']">Materials</button>
  </div>
</div>



<div class="board-header" *ngIf="!firstLoading">
  <div class="board-bar">

    <div class="board-button">
      <button mat-button class="create-order-button" (click)="createNewOrder()">
        <mat-icon>add</mat-icon>
        <div class="button-title">New Order</div>
      </button>
    </div>

    <div class="vendors-switch multiselect-block"
         [ngClass]="{'all-vendors': selectedVendors.length === vendors.length}">
      <p-multiSelect [defaultLabel]="'Vendors'" [selectedItemsLabel]="vendorFiltersLabel" [options]="vendors"
                     optionLabel="name" [(ngModel)]="selectedVendors" [showToggleAll]="true" (onChange)="updateFilter()"
                     [filter]="false" [maxSelectedLabels]="1">
        <p-header>
          <div (click)="toggleVendors()">Show All</div>
        </p-header>
      </p-multiSelect>
    </div>

    <div class="project-switch multiselect-block" [ngClass]="{'proj-selected': !ordersProject}">
      <p-dropdown (onChange)="projectChange($event)" [options]="ordersProjects" [(ngModel)]="ordersProject"
                  [showClear]="true" placeholder="Project" optionLabel="name" [filter]="true"
                  filterBy="name,number"
                  [styleClass]="'project-order-filter'"></p-dropdown>
    </div>

    <div class="vendors-switch multiselect-block"
         [ngClass]="{'all-vendors': selectedStatuses.length === statuses.length}">
      <p-multiSelect [defaultLabel]="'Statuses'" [selectedItemsLabel]="statusesFiltersLabel" [options]="statuses"
                     optionLabel="name" [(ngModel)]="selectedStatuses" [showToggleAll]="true"
                     (onChange)="updateFilter()"
                     [filter]="false" [maxSelectedLabels]="1">
        <p-header>
          <div (click)="toggleStatuses()">Show All</div>
        </p-header>
      </p-multiSelect>
    </div>
  </div>
</div>

<div class="order-middle" *ngIf="firstLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>


<div class="order-middle" *ngIf="!firstLoading">
  <div class="order header-order">
    <div class="status-block">
      <div class="status-name">Status</div>
    </div>
    <div class="order-block">
      <div class="order-name">Number</div>
    </div>
    <div class="vendor-block">
      <div class="vendor-name">Vendor</div>
    </div>
    <div class="project-block">
      <div class="project-name">Project</div>
    </div>
    <div class="date-block">
      <div class="project-name">Date</div>
    </div>
    <div class="date-block">
      <div class="project-name"></div>
    </div>
    <div class="date-block">
      <div class="project-name">Expected Date</div>
    </div>
    <div class="date-block">
      <div class="project-name">Total</div>
    </div>
  </div>

  <div class="orders-block loading-orders-block" *ngIf="ordersLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div class="orders-block" *ngIf="!ordersLoading">
    <div class="order">
      <p-accordion [activeIndex]="openedOrders" (onOpen)="openOrderTab($event)" (onClose)="closeOrderTab($event)"
                   [multiple]="true">
        <p-accordionTab class="order-tab"
                        *ngFor="let orderToSubmit of ordersToSubmit; trackBy: trackEntityById; index as i"
                        [ngClass]="{'order-submitted': orderToSubmit.order.status?.name === 'Submitted', 'order-delivered': orderToSubmit.order.status?.name === 'Delivered', 'order-confirmed': orderToSubmit.order.status?.name === 'Confirmed', 'order-backordered': orderToSubmit.order.status?.name === 'Backordered'}">
          <p-header>
            <div class="status-block">
              <div class="status-name">{{orderToSubmit.order.status?.title}}</div>
            </div>
            <div class="order-block">
              <div class="order-name">{{orderToSubmit.order.number}}</div>
            </div>
            <div class="vendor-block">
              <div class="vendor-name">{{orderToSubmit.order.vendor?.name}}</div>
            </div>
            <div class="project-block">
              <div class="project-name">{{orderToSubmit.order.project?.name}}</div>
            </div>
            <ng-container *ngIf="orderToSubmit.order.status?.name === 'New'">
              <div class="date-block">
                <div class="date-name"><span class="date-label">Created:</span>
                  {{orderToSubmit.order.createdDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="date-label"></span>
                  <!-- {{orderToSubmit.order.expectedDeliveryDate | date: 'dd MMM'}} -->
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="delivery-label date-label">Submit By:</span>
                  {{orderToSubmit.order.expectedSubmitDate | date: 'dd MMM'}}</div>
              </div>
              <div class="total-block">
                <div class="number-block">
                  <!--                  <span class="number-label">Total:</span>-->
                  ${{orderToSubmit.order.total | number: '1.2-2'}}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="orderToSubmit.order.status?.name === 'Submitted'">
              <div class="date-block">
                <div class="date-name"><span class="date-label">Created:</span>
                  {{orderToSubmit.order.createdDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="date-label">Submitted:</span>
                  {{orderToSubmit.order.submittedDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="delivery-label date-label">Delivery ETA:</span>
                  {{orderToSubmit.order.expectedDeliveryDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="total-block">
                <div class="number-block">
                  <!--                  <span class="number-label">Total:</span>-->
                  ${{orderToSubmit.order.total | number: '1.2-2'}}</div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="orderToSubmit.order.status?.name === 'Confirmed' || orderToSubmit.order.status?.name === 'Backordered'">
              <div class="date-block">
                <div class="date-name"><span class="date-label">Submitted:</span>
                  {{orderToSubmit.order.submittedDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="date-label">Confirmed:</span>
                  {{orderToSubmit.order.confirmedDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="delivery-label date-label">Delivery ETA:</span>
                  {{orderToSubmit.order.expectedDeliveryDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="total-block">
                <div class="number-block">
                  <!--                  <span class="number-label">Total:</span>-->
                  ${{orderToSubmit.order.total | number: '1.2-2'}}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="orderToSubmit.order.status?.name === 'Delivered'">
              <div class="date-block">
                <div class="date-name"><span class="date-label">Created:</span>
                  {{orderToSubmit.order.createdDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="date-label">Confirmed:</span>
                  {{orderToSubmit.order.confirmedDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="date-block">
                <div class="date-name"><span class="delivery-label date-label">Delivered:</span>
                  {{orderToSubmit.order.deliveredDate | date: 'dd MMM'}}
                </div>
              </div>
              <div class="total-block">
                <div class="number-block">
                  <!--                                  <span class="number-label">Total:</span>-->
                  ${{orderToSubmit.order.total | number: '1.2-2'}}</div>
              </div>
            </ng-container>
          </p-header>

          <div class="materials-body-block">
            <app-material-table [items]="orderToSubmit.order.items" [orderId]="orderToSubmit.order.id"
                                [orderStatus]="orderToSubmit.order.status?.name"
                                (orderIsEdited)="orderIsEdited(orderToSubmit)"></app-material-table>

            <div class="materials-bottom-block">
              <div class="materials-notes">
                {{orderToSubmit.order.notes}}
              </div>

              <div class="materials-total-price">
                Total: {{orderToSubmit.order.total | number:'1.2-2'}}
              </div>
            </div>
            <div class="buttons-block">
              <button mat-button (click)="deleteOrder(orderToSubmit.order, i)"
                      class="order-button delete-order" *ngIf="orderToSubmit.order.status?.name === 'New'"
                      [disabled]="deleteLoading === orderToSubmit.order.id"
                      [ngClass]="{'disabled-button': deleteLoading === orderToSubmit.order.id}">
                <span *ngIf="deleteLoading !== orderToSubmit.order.id">Delete</span>
                <lib-mini-progress-spinner *ngIf="deleteLoading === orderToSubmit.order.id">
                </lib-mini-progress-spinner>
              </button>

              <div class="space-block"></div>

              <button mat-button (click)="openProjectWindow(orderToSubmit.order.project.id)"
                      class="order-button open-order">
                <span>Open Project</span>
              </button>

              <button mat-button (click)="openOrder(orderToSubmit.order)"
                      *ngIf="orderToSubmit.order.status?.name !== 'Delivered'"
                      class="order-button edit-order">
                <span>Edit</span>
              </button>

              <button mat-button (click)="orderIsEdited(orderToSubmit)" class="order-button save-order"
                      [disabled]="saveLoading === orderToSubmit.order.id"
                      [ngClass]="{'disabled-button': saveLoading === orderToSubmit.order.id}">
                <span *ngIf="saveLoading !== orderToSubmit.order.id">Save</span>
                <lib-mini-progress-spinner *ngIf="saveLoading === orderToSubmit.order.id">
                </lib-mini-progress-spinner>
              </button>

              <button mat-button (click)="confirmOrder(orderToSubmit.order)"
                      class="order-button confirm-order"
                      *ngIf="orderToSubmit.order.status?.name === 'New' || orderToSubmit.order.status?.name === 'Submitted'"
                      [disabled]="buttonLoading" [ngClass]="{'disabled-button': buttonLoading}">
                <span *ngIf="!buttonLoading">Confirm</span>
                <lib-mini-progress-spinner *ngIf="buttonLoading"></lib-mini-progress-spinner>
              </button>

              <button mat-button (click)="submitOrder(orderToSubmit.order, $event)"
                      class="order-button submit-order" *ngIf="orderToSubmit.order.status?.name === 'New'"
                      [disabled]="buttonLoading" [ngClass]="{'disabled-button': buttonLoading}">
                <span *ngIf="!buttonLoading">Submit</span>
                <lib-mini-progress-spinner *ngIf="buttonLoading"></lib-mini-progress-spinner>
              </button>

              <button mat-button (click)="acceptDelivery(orderToSubmit.order)"
                      class="order-button accept-order"
                      *ngIf="orderToSubmit.order.status?.name === 'Submitted' || orderToSubmit.order.status?.name === 'Confirmed' || orderToSubmit.order.status?.name === 'Backordered' ">
                <span>Accept Delivery</span>
              </button>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>

    </div>

    <p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="project-panel">
    </p-confirmDialog>
  </div>

  <div class="paginator-block">
    <p-paginator #orderPaginator [rows]="ordersPerPage" [totalRecords]="totalRecords"
                 (onPageChange)="getOrdersLazy($event.page, $event.rows)">
    </p-paginator>
  </div>
</div>
